<template>
  <div>
    <b-loading :is-full-page="isFullPage" :active.sync="isLoading"></b-loading>
    <div id="url_expired" style="text-align: center; width: 90%;">
      <h4>Welcome to Doodhvale, Please wait...</h4>
    </div>
    <div id="url_valid">
      <div style="text-align: center;">
        <b-tabs position="is-centered" class="block">
          <b-tab-item label="Zones">
            <div v-if="table_load === true">
              <div style="text-align: center; margin-top: 20px;"><strong>{{apiDataObj.route}} ({{apiDataObj.date}})</strong></div>
              <div class="container is-fluid has-text-centered">
                <div v-for="(zoneData,zone) in zones">
                  <b-collapse :open="false" class="show panel">
                      <div slot="trigger" class="panel-heading collapseheader" role="button">
                        {{zone}} ({{zoneData.orders}})
                      </div>
                      <table>
                      <tbody>
                        <tr>
                          <th class="is-fluid has-text-centered headercss">Products</th>
                          <th class="is-fluid has-text-centered headercss">Order</th>
                          <th class="is-fluid has-text-centered headercss">Delivered</th>
                        </tr>
                        <tr v-for="product in zoneData.products">
                          <td>{{product.product_name}}</td>
                          <td>{{product.quantity}}</td>
                          <td>{{product.delivered}}</td>
                        </tr>
                        <tr>
                          <th class="is-fluid has-text-centered footercss">Total</th>
                          <th class="is-fluid has-text-centered footercss">{{zoneData.total}}</th>
                          <th class="is-fluid has-text-centered footercss">{{zoneData.delivered}}</th>
                        </tr>
                      </tbody>
                      </table>
                  </b-collapse>
                  <!-- <thead>
                    <tr>
                      <th class="is-fluid has-text-centered" colspan="3">{{product.prod_name}}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <th class="is-fluid has-text-centered">Dispatcher</th>
                      <th class="is-fluid has-text-centered">Order</th>
                      <th class="is-fluid has-text-centered">Delivered</th>
                    </tr>
                    <tr v-for="row in product.order_summary">
                      <td>{{row.disp_name}}</td>
                      <td>{{row.order}}</td>
                      <td>{{row.delivered}}</td>
                    </tr>
                    <tr>
                      <th class="is-fluid has-text-centered">Total</th>
                      <th class="is-fluid has-text-centered">{{product.orderQuantity}}</th>
                      <th class="is-fluid has-text-centered">{{product.deliveredQuantity}}</th>
                    </tr>
                  </tbody> -->
                </div>
              </div>
            </div>
          </b-tab-item>
          <b-tab-item label="Products">
            <div v-if="table_load === true">
              <div style="text-align: center; margin-top: 20px;"><strong>{{apiDataObj.route}} ({{apiDataObj.date}})</strong></div>
              <div class="container is-fluid has-text-centered">
                <div v-for="product in products">
                  <b-collapse :open="false" class="show panel">
                      <div slot="trigger" class="panel-heading collapseheader" role="button">
                        {{product.prod_name}}
                      </div>
                      <table>
                      <tbody>
                        <tr>
                          <th class="is-fluid has-text-centered headercss">Dispatcher</th>
                          <th class="is-fluid has-text-centered headercss">Order</th>
                          <th class="is-fluid has-text-centered headercss">Delivered</th>
                        </tr>
                        <tr v-for="row in product.order_summary">
                          <td>{{row.disp_name}}</td>
                          <td>{{row.order}}</td>
                          <td>{{row.delivered}}</td>
                        </tr>
                        <tr>
                          <th class="is-fluid has-text-centered footercss">Total</th>
                          <th class="is-fluid has-text-centered footercss">{{product.orderQuantity}}</th>
                          <th class="is-fluid has-text-centered footercss">{{product.deliveredQuantity}}</th>
                        </tr>
                      </tbody>
                      </table>
                  </b-collapse>
                  <!-- <thead>
                    <tr>
                      <th class="is-fluid has-text-centered" colspan="3">{{product.prod_name}}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <th class="is-fluid has-text-centered">Dispatcher</th>
                      <th class="is-fluid has-text-centered">Order</th>
                      <th class="is-fluid has-text-centered">Delivered</th>
                    </tr>
                    <tr v-for="row in product.order_summary">
                      <td>{{row.disp_name}}</td>
                      <td>{{row.order}}</td>
                      <td>{{row.delivered}}</td>
                    </tr>
                    <tr>
                      <th class="is-fluid has-text-centered">Total</th>
                      <th class="is-fluid has-text-centered">{{product.orderQuantity}}</th>
                      <th class="is-fluid has-text-centered">{{product.deliveredQuantity}}</th>
                    </tr>
                  </tbody> -->
                </div>
              </div>
            </div>
          </b-tab-item>
        </b-tabs>
      </div>
    </div>
  </div>
</template>
<script>
  import ChartCard from 'src/components/UIComponents/Cards/ChartCard.vue'
  import StatsCard from 'src/components/UIComponents/Cards/StatsCard.vue'
  import Card from 'src/components/UIComponents/Cards/Card.vue'
  import LTable from 'src/components/UIComponents/Table.vue'
  import Checkbox from 'src/components/UIComponents/Inputs/Checkbox.vue'
  import axios from 'axios'
  export default {
    components: {
      Checkbox,
      Card,
      LTable,
      ChartCard,
      StatsCard
    },
    data () {
      return {
        urlInterface: [],
        apiDataObj: [],
        userDetails: [],
        table_load: false,
        isLoading: true,
        isFullPage: true,
        isOpen: false,
        products: [],
        zones: {}
      }
    },
    created () {
      this.fetchData()
    },
    methods: {
      fetchData () {
        const params = new URLSearchParams()
        var fullUrl = document.URL
        var splitUrl = fullUrl.split('td?')
        params.append('url_str', splitUrl[1])
        axios({
          url: process.env.BASE_API + '/accounts/fetch-url-interface-data',
          method: 'post',
          data: params,
          withCredentials: false,
          headers: {
          }
        })
        .then(response => {
          // console.log(response)
          this.urlInterface = {}
          if (response.data.status === '000001' || response.data.status === '000002' || response.data.status === '000003') {
            this.isLoading = false
            this.urlInterface.error_msg = response.data.msg
            document.getElementById('url_valid').style.display = 'none'
          } else {
            document.getElementById('url_expired').style.display = 'none'
            this.urlInterface.action_name = response.data.action_name
            this.urlInterface.url_interface_id = response.data.url_interface_id
            this.invokeUrlAction()
          }
          if (response.data.status.trim().toUpperCase() === 'SUCCESS') {
            this.list = response.data.user_record
            alert(this.list)
          }
        })
        .catch(e => {
          alert('not ok')
        })
      },

      invokeUrlAction () {
        const params = new URLSearchParams()
        params.append('url_interface_id', this.urlInterface.url_interface_id)
        params.append('action_name', this.urlInterface.action_name)
        axios({
          url: process.env.BASE_API + '/accounts/invoke-url-action',
          method: 'post',
          data: params,
          withCredentials: false,
          headers: {
          }
        })
        .then(response => {
          // console.log(response)
          this.apiDataObj = {}
          switch (this.urlInterface.action_name) {
            case 'total_delhi':
            case 'noida_route':
            case 'gurugram_route':
            case 'total_delhi_vegetable_orders':
            case 'total_delhi_fruit_orders':
            case 'total_delhi_bakery_orders':
            case 'total_delhi_vegetable_orders_suppliers':
            case 'total_delhi_fruit_orders_suppliers':
            case 'total_delhi_bakery_orders_suppliers':
            default:
              this.apiDataObj.userId = response.data.action_response.user_id
              this.apiDataObj.date = response.data.action_response.date
              this.apiDataObj.route = response.data.action_response.route
              this.apiDataObj.orderQuantity = response.data.action_response.orderQuantity
              this.apiDataObj.deliveredQuantity = response.data.action_response.deliveredQuantity
              this.products = response.data.action_response.productData
              this.zones = response.data.action_response.zonesData
              this.table_load = true
              this.isLoading = false
              // this.userInfo()
              break
          }
          if (response.data.status.trim().toUpperCase() === 'SUCCESS') {
            this.list = response.data.user_record
            alert(this.list)
          }
        })
        .catch(e => {
          alert('not ok')
        })
      },

      userInfo () {
        const params = new URLSearchParams()
        var userId = this.apiDataObj.userId
        params.append('user_id', userId)
        axios({
          url: process.env.BASE_API + '/users/user-info',
          method: 'post',
          data: params,
          withCredentials: false,
          headers: {
          }
        })
        .then(response => {
          this.userDetails = {}
          this.userDetails.userId = userId
          this.userDetails.first_name = response.data.user_record.user_details.first_name
          this.userDetails.mobile = response.data.user_record.user.username
          this.userDetails.address = response.data.user_record.address.address1 + ' ' + response.data.user_record.address.address2 + ' ' + response.data.user_record.address.city
          // console.log(response)
          if (response.data.status.trim().toUpperCase() === 'SUCCESS') {
            this.list = response.data.user_record
            alert(this.list)
          }
        })
        .catch(e => {
          alert('not ok')
        })
      }
    }
  }
</script>
<style>
.collapseheader {
  text-transform: uppercase;
  text-align: left;
  background: #44475C;
  color: #FFF;
  padding: 8px;
  border:3px solid #44475C;
  margin-top:5px;
  text-align: center;
  min-width: 30px;
}
.container {
  width: 100%;
  padding: 8px !important;
  /* padding-right: 0px !important;
  padding-left: 0px !important; */
  margin-right: auto;
  margin-left: auto;
}
table {
  font-family: 'Open Sans', sans-serif;
  width: 100%;
  border-collapse: collapse;
  border: 3px solid #44475C;
}

table th {
  text-transform: uppercase;
  text-align: left;
  background: #44475C;
  color: #FFF;
  padding: 8px;
  min-width: 30px;
}

.footercss {
  text-transform: uppercase;
  text-align: left;
  background: #5ac75a;
  color: #FFF;
  padding: 8px;
  min-width: 30px;
}

.headercss {
  text-transform: uppercase;
  text-align: left;
  background: #858690;
  color: #FFF;
  padding: 8px;
  min-width: 30px;
}

table td {
  text-align: center;
  padding: 8px;
  border-right: 2px solid #7D82A8;
}
table td:last-child {
  border-right: none;
}
table tbody tr:nth-child(2n) td {
  background: #D4D8F9;
}
.footer {
  padding: 0rem 0rem 0rem !important;
}

</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/Td.vue